// extracted by mini-css-extract-plugin
export default {"button":"startPage_button__vs5Cl","big_logo":"startPage_big_logo__hvOmg"};